import { useState, useEffect } from 'react';
import { INITIAL_MOVES } from './data/moves';
import { INITIAL_GYMNAST_FRIENDS } from './data/friends';
import { useProgress } from './hooks/useProgress';
import PrototypeSwitcher, { VariantMeta } from './components/PrototypeSwitcher';
import VariantA from './components/variants/VariantA';
import VariantB from './components/variants/VariantB';
import VariantC from './components/variants/VariantC';

const PROTOTYPE_VARIANTS: VariantMeta[] = [
  { id: 'A', name: 'Big Card Stage & Buddy' },
  { id: 'B', name: 'Stepping Stones Map' },
  { id: 'C', name: 'Team Studio & Checklist' },
];

export default function App() {
  const [variant, setVariant] = useState<string>(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant')?.toUpperCase() || 'A';
  });

  const { progress, toggleStep, setActiveFriend, resetAll } = useProgress();

  useEffect(() => {
    const handlePopState = () => {
      const params = new URLSearchParams(window.location.search);
      setVariant(params.get('variant')?.toUpperCase() || 'A');
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleSelectVariant = (newVariantId: string) => {
    setVariant(newVariantId);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', newVariantId);
    window.history.pushState({}, '', url.toString());
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-50 to-blue-100 text-slate-800">
      {/* Locked in Variant A as the official winner */}
      {variant === 'B' ? (
        <VariantB
          moves={INITIAL_MOVES}
          friends={INITIAL_GYMNAST_FRIENDS}
          progress={progress}
          onToggleStep={toggleStep}
          onSelectFriend={setActiveFriend}
          onResetProgress={resetAll}
        />
      ) : variant === 'C' ? (
        <VariantC
          moves={INITIAL_MOVES}
          friends={INITIAL_GYMNAST_FRIENDS}
          progress={progress}
          onToggleStep={toggleStep}
          onSelectFriend={setActiveFriend}
          onResetProgress={resetAll}
        />
      ) : (
        <VariantA
          moves={INITIAL_MOVES}
          friends={INITIAL_GYMNAST_FRIENDS}
          progress={progress}
          onToggleStep={toggleStep}
          onSelectFriend={setActiveFriend}
          onResetProgress={resetAll}
        />
      )}

      {/* Floating Bottom Switcher (visible only if ?switcher=true) */}
      {new URLSearchParams(window.location.search).get('switcher') === 'true' && (
        <PrototypeSwitcher
          variants={PROTOTYPE_VARIANTS}
          currentVariant={variant}
          onSelectVariant={handleSelectVariant}
        />
      )}
    </div>
  );
}
